<template>
  <div>
    <PageHead title="草稿箱"></PageHead>
    <div class="drafts oa-layout-content">
      <a-table
        :pagination="false"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
        <div slot="action" slot-scope="text, record">
          <a-button type="link" class="btn-link" @click="goDetial(record.id)">
            修改
          </a-button>
          <a-divider type="vertical" />
          <a-button
            type="link"
            class="btn-link"
            @click="showDeleteConfirm(record.id)"
          >
            删除
          </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>

<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: { customRender: 'index' },
    width: 80,
    align: 'center'
  },
  {
    title: '项目名称',
    dataIndex: 'projectName',
    key: 'projectName',
    ellipsis: true
  },
  {
    title: '项目申请部门/单位',
    dataIndex: 'organizationName',
    key: 'organizationName'
  },

  {
    title: '项目预算',
    dataIndex: 'totalPrice',
    key: 'totalPrice'
  },
  {
    title: '经办人',
    dataIndex: 'userName',
    key: 'userName'
  },
  {
    title: '上报时间',
    dataIndex: 'projectApplyTime',
    key: 'projectApplyTime',
    ellipsis: true
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'left',
    width: 180
  }
]
import { ProjectApplyDraftlist, delProjectApply } from './api/api'
export default {
  data() {
    return {
      data: [],
      columns,
      total: 0,
      page: 1,
      size: 10,
      loading: false
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      let params = {
        page: this.page,
        size: this.size
      }
      ProjectApplyDraftlist(params).then((res) => {
        this.loading = false
        if (res.data.code == 0) {
          this.data = res.data.data
          this.total = res.data.count
        }
      })
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          delProjectApply({ id }).then((res) => {
            if (res.data.code == 0) {
              this.$message.success('删除成功')
              this.page = 1
              this.load()
            }
          })
        }
      })
    },
    goDetial(id) {
      if (id) {
        this.$router.push({
          path: '/ProjectApplicationDetial',
          query: {
            id
          }
        })
      } else {
        this.$router.push('/ProjectApplicationDetial')
      }
    },
    pageChange(pageber) {
      this.page = pageber
      this.load()
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/ProjectApplication/drafts.vue